/* global wc_checkout_params */
jQuery(document).ready(function ($) {
    $('.woocommerce-form-coupon.ghost-div-form').on('click', 'button[type=submit]', function (e) {
        e.preventDefault();
        var $coupon_input = $(this).closest('.woocommerce-form-coupon').find('input[name=coupon_code]');
        var coupon_code = $coupon_input.val();
        var data = {
            security: wc_checkout_params.apply_coupon_nonce,
            coupon_code: coupon_code
        };
        var $form = $('form.woocommerce-checkout');
        $form.addClass('processing');

        $.ajax({
            type: 'POST',
            url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
            data: data,
            success: function (code) {
                $('.woocommerce-error, .woocommerce-message').remove();
                $form.removeClass('processing').unblock();

                if (code) {
                    $form.before(code);
                    $(document.body).trigger('applied_coupon_in_checkout', [data.coupon_code]);
                    $(document.body).trigger('update_checkout', {update_shipping_method: false});
                    $coupon_input.val("");
                }
            },
            dataType: 'html'
        });
    });
});
